import { LoadableRoute } from 'routes/utils/loadable';

export const SignUpContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "SignUp" */ './SignUp'),
});
